export default __webpack_public_path__ + "static/media/info.410becd2.svg";